import 'pages/contacts/contact-details/notes-tab/index.css'

// TODO: move into local styles
import React from 'react'

import type { TrackId } from 'types/track'

import CopyMetadataButton from 'components/common/tracks/copy-metadata-button'
import { Flex, Text, TextArea } from 'components/ds'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import InlineError from 'components/ui/inline-error'
import SwitchContainer from 'components/ui/switch/container'

import { useSelector } from 'hooks/use-redux'

type Comment = Record<string, any>
type Props = {
  trackId: TrackId | null | undefined
  trackIds?: TrackId[]
  comment: Comment
  saving: boolean
  onClose?: (...args: Array<any>) => any
  onVisibilityChange: (visibility: 'internal' | 'client') => void
  onCommentCancel: (evt: React.SyntheticEvent<any>) => void
  onCommentSave: (evt: React.SyntheticEvent<any>) => void
  onCommentChange: (evt: React.ChangeEvent<HTMLTextAreaElement>) => void
}

const EditMetadataComment = (props: Props): React.ReactElement<'div'> => {
  const error = useSelector(state => state.server.error)
  const showError = useSelector(state => state.server.showError)

  const onSave = (evt: React.SyntheticEvent<any>) => {
    props.onCommentSave(evt)
  }

  return (
    <div>
      {showError && <InlineError error={String(error)} />}
      <Flex direction="column" gap="2">
        <Flex direction="column" gap="2" className="notes-tab__actions">
          <Text as="label" size="2">
            {props.comment.isNew ? (
              <span>Add a note</span>
            ) : (
              <span>Edit note</span>
            )}
          </Text>
          <TextArea
            value={props.comment.comment}
            onChange={props.onCommentChange}
            rows={12}
            grow={false}
          />
        </Flex>
        <div className="notes-tab__visibility">
          <SwitchContainer>
            <SwitchContainer.SwitchLabel label="Make this note visible to clients" />
            <SwitchContainer.Switch
              value={props.comment.visibility === 'client'}
              onChange={(v) =>
                props.onVisibilityChange(v ? 'client' : 'internal')
              }
            />
          </SwitchContainer>
        </div>
      </Flex>
      <div className="notes-tab__actions">
        <DialogFooter
          onClose={!props.comment.isNew ? props.onCommentCancel : props.onClose}
          primary={
            <ButtonContainer>
              {props.comment.isNew && !props.trackId && props.trackIds && (
                <CopyMetadataButton trackIds={props.trackIds} />
              )}
              {props.comment.isNew && props.trackId && (
                <CopyMetadataButton trackIds={[props.trackId]} />
              )}
              <Button
                progressCaption="Saving"
                progressIndicator={props.saving}
                appearance="primary"
                caption={props.comment.isNew ? 'Add note' : 'Update note'}
                onClick={onSave}
              />
            </ButtonContainer>
          }
        />
      </div>
    </div>
  )
}

export default EditMetadataComment
